export enum InfoType {
  phone = "phone",
  address = "address",
  patriotAct = "patriotAct",
}
